import React from "react";
import "./App.css";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

function App() {
  return (
    <>
      <nav className="navbar navbar-expand-lg app__navbar navbar-dark">
        <a className="navbar-brand ml-3 app__navbarBrand" href="#">
          Aashish
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          {/* write ur code here */}
          <ul className="navbar-nav ml-auto mr-3">
            <li className="nav-item header__right">
              <a href="#home" className="nav-link">
                Home
              </a>
            </li>
            <li className="nav-item header__right">
              <a href="#project" className="nav-link">
                projects
              </a>
            </li>
            <li className="nav-item header__right">
              <a href="#contact" className="nav-link">
                contact
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div id="home" className="container">
        <div className="row mt-5">
          <div className="col home__intro">
            <p className="home__userInfoIntro">Hi, my name is</p>
            <h2 className="home__userInfoName">Aashish Upadhyay.</h2>
            <p className="home__userInfoWork">I'm a Software Developer.</p>
            <p className="home__userInfoDescription">
              I'm a Software Developer who is specialized in building
              websites(both full stack and static) using various hot
              technologies like React, Redux, Express, node, firebase and so on.
            </p>

            <a href="#about">
              <ExpandMoreIcon />
            </a>
          </div>
          <div className="col image__col">
            <img
              className="user__image ml-auto mr-auto"
              src="https://scontent.fktm3-1.fna.fbcdn.net/v/t1.15752-9/170620525_224173466125701_83513646204621051_n.jpg?_nc_cat=108&ccb=1-3&_nc_sid=ae9488&_nc_ohc=JI1HY0fpIQkAX_1kyk3&_nc_ht=scontent.fktm3-1.fna&oh=1ae1aca3505da219726a2cfc94e68b61&oe=60931F50"
            />
          </div>
        </div>

        {/* about section */}

        <div className="row mt-5">
          <p id="about" className="about__title">
            About me
          </p>
        </div>
        <div className="row">
          <p className="about__description">
            Hey, My name is Aashish Upadhyay, currently a undergrad student in
            Computer Engineering. I started coding few years ago when I was in
            my middle school. On the way, I have learnt various technologies
            like machine learning fundamentals, web development with python
            django and java programming as well. But now I'm mainly focus on
            javascript and developing projects with React.js and node.js.
          </p>
        </div>

        {/* projects  */}
        <div className="row">
          <p id="project" className="project__header mt-5">
            Projects
          </p>
        </div>

        {/* project card  */}
        <div className="row">
          <div className="col-sm-4">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Todo List</h5>
                <p className="card-text">
                  This is the simple todo list app completely made with React.js
                  and node.js.
                </p>
                <a
                  href="https://github.com/Aashish-Upadhyay-101/React-todolist"
                  className="btn btn-outline-warning"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Chat App</h5>
                <p className="card-text">
                  This program use firebase as a backend service for realtime
                  database. The main feature of this app is the person's name
                  will be anonymous.
                </p>
                <a
                  href="https://github.com/Aashish-Upadhyay-101/reactChatApp"
                  className="btn btn-outline-warning"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Amazon Clone</h5>
                <p className="card-text">
                  A complete frontend of real amazon website with the firebase
                  authentication and hosting.
                </p>
                <a
                  href="https://github.com/Aashish-Upadhyay-101/amazon-clone-with-firebase_authentication"
                  className="btn btn-outline-warning"
                >
                  Learn More
                </a>
              </div>
            </div>
          </div>

          {/* contact section */}
          <div id="contact" className="row contact mt-5">
            <p className="contact__title">Get In Touch</p>
            <p className="contact__description">
              Hey, my inbox is always open. Whether you have a question or just
              want to say hi, I'll do my best to get back to you!
            </p>
            <button className="btn btn-outline-warning email__btn">
              hbeing427@gmail.com
            </button>
          </div>

          <p className="footer ">
            Designed and Developed by Aashish Upadhyay © CopyRight 2021
          </p>
        </div>
      </div>
    </>
  );
}

export default App;
